// frontend/src/components/book/FaqSection.jsx
import React, { useState, useEffect } from 'react';
import { api } from '../../api';
import { colors, fontFamily } from '../../theme';

export default function FaqSection() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getRules()
      .then(data => setFaqs(data.faqs || []))
      .catch(err => console.error('Failed to load FAQ:', err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ color: colors.textPrimary, fontFamily }}>
      <h2 style={{ marginBottom: '1rem' }}>F.A.Q</h2>
      <div style={{ background: colors.cardBg, boxShadow: colors.shadowCard, borderRadius: 8, padding: '1.5rem' }}>
        {loading && <p style={{ color: colors.textMuted }}>Loading…</p>}
        {!loading && faqs.length === 0 && (
          <p style={{ color: colors.textMuted, textAlign: 'center' }}>No F.A.Q content yet.</p>
        )}
        {!loading && faqs.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
            {faqs.map((item, i) => (
              <div key={item.id} style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
                <span style={{ color: colors.gold, fontWeight: 700, minWidth: 24, flexShrink: 0 }}>{i + 1}.</span>
                <span style={{ color: colors.textPrimary, fontSize: '0.95rem', lineHeight: 1.6 }}>{item.content}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
